"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var instructor_footer_nav_html_1 = __importDefault(require("./instructor-footer-nav.html"));
function dcInstructorFooterNav(NavigationHistoryService, $window) {
    return {
        restrict: "E",
        scope: {},
        template: instructor_footer_nav_html_1.default,
        link: function (scope, element, attrs) {
            scope.navBack = function () {
                if (NavigationHistoryService.getHistory().length > 1) {
                    $window.history.back();
                }
            };
        },
    };
}
dcInstructorFooterNav.$inject = ["NavigationHistoryService", "$window"];
exports.default = dcInstructorFooterNav;
